(function () {
  if (window.__pdpOfferBooted) return;
  window.__pdpOfferBooted = true;

  // ---------- Currency formatting (shop currency from window.Shopify) ----------
  var shopCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  var moneyFormatter = null;
  try {
    moneyFormatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: shopCurrency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } catch (e) {
    moneyFormatter = null;
  }
  function fmtMoney(cents) {
    var n = (cents || 0) / 100;
    if (moneyFormatter) return moneyFormatter.format(n);
    return '$' + n.toFixed(2);
  }

  // ---------- Volume tiers ----------
  function initVolumeTiers(root) {
    var variantsScript = root.querySelector('script[data-vt-variants]');
    var variants = [];
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }
    }
    var tier2Pct = parseInt(root.getAttribute('data-tier2-pct'), 10) || 5;
    var tier3Pct = parseInt(root.getAttribute('data-tier3-pct'), 10) || 10;
    var formId = root.getAttribute('data-product-form-id');
    var sectionId = root.getAttribute('data-section-id');

    function currentVariant() {
      var form = formId ? document.getElementById(formId) : null;
      if (!form) form = document.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var id = idInput ? parseInt(idInput.value, 10) : null;
      if (!id) {
        // Fall back to data-base-cents (Liquid-rendered default)
        return { price: parseInt(root.getAttribute('data-base-cents'), 10) || 0 };
      }
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i];
      }
      return { price: parseInt(root.getAttribute('data-base-cents'), 10) || 0 };
    }

    function recalc() {
      var v = currentVariant();
      var base = v.price || 0;

      var tiers = root.querySelectorAll('[data-vt-qty]');
      tiers.forEach(function (tier) {
        var qty = parseInt(tier.getAttribute('data-vt-qty'), 10) || 1;
        var pct = 0;
        if (qty === 2) pct = tier2Pct;
        else if (qty === 3) pct = tier3Pct;

        var fullCents = base * qty;
        var saveCents = Math.round(fullCents * pct / 100);
        var totalCents = fullCents - saveCents;
        var perCents = Math.round(totalCents / qty);

        var perEl = tier.querySelector('[data-vt-per]');
        var totalEl = tier.querySelector('[data-vt-total]');
        var saveEl = tier.querySelector('[data-vt-save]');
        if (perEl) perEl.textContent = fmtMoney(perCents) + ' each';
        if (totalEl) totalEl.textContent = fmtMoney(totalCents);
        if (saveEl) {
          if (saveCents > 0) {
            saveEl.textContent = 'Save ' + fmtMoney(saveCents);
          } else {
            saveEl.textContent = '';
          }
        }
      });

      // Update the shipping progress (if present) based on current tier × variant
      updateShippingProgress(sectionId);
    }


    function syncQuantityInput(qty) {
      var form = formId ? document.getElementById(formId) : null;
      if (!form) form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput) {
        qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        form.appendChild(qtyInput);
      }
      qtyInput.value = qty;
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Tier change handlers
    root.addEventListener('change', function (e) {
      var radio = e.target.closest('input[type="radio"]');
      if (!radio) return;
      var tier = radio.closest('[data-vt-qty]');
      if (!tier) return;
      // Update visual selected state (move .vt-row--selected to chosen row)
      root.querySelectorAll('.vt-row').forEach(function (r) {
        r.classList.toggle('vt-row--selected', r === tier);
      });
      syncQuantityInput(parseInt(tier.getAttribute('data-vt-qty'), 10) || 1);
      updateShippingProgress(sectionId);
    });

    // Initial sync: 1 jar is functionally checked
    syncQuantityInput(1);
    recalc();

    // Live recalc when variant changes (size, scent)
    function maybeRecalc() {
      requestAnimationFrame(recalc);
    }

    // FoxTheme pubsub if available
    if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS) {
      try {
        window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, maybeRecalc);
      } catch (e) { /* ignore */ }
    }

    // Catch native variant-selects change too
    document.querySelectorAll('variant-selects[data-section="' + sectionId + '"]').forEach(function (vs) {
      vs.addEventListener('change', maybeRecalc);
    });

    // The form's hidden id input — observe for value changes via input event
    var form = formId ? document.getElementById(formId) : null;
    if (form) {
      form.addEventListener('change', maybeRecalc);
    }
  }

  // ---------- Per-unit on size picker ----------
  // Parse a size like "2 Ounce" / "4oz" / "8 oz" / "100ml" → numeric oz (ml normalised)
  function parseSize(text) {
    if (!text) return null;
    var t = String(text).toLowerCase().replace(/\s+/g, '');
    var m = t.match(/(\d+(?:\.\d+)?)(oz|ounce|ounces)/);
    if (m) return { qty: parseFloat(m[1]), unit: 'oz' };
    var ml = t.match(/(\d+(?:\.\d+)?)(ml|millilitres?|milliliters?)/);
    if (ml) return { qty: parseFloat(ml[1]), unit: 'ml' };
    return null;
  }

  function loadVariants() {
    var vt = document.querySelector('volume-tiers');
    if (!vt) return [];
    var script = vt.querySelector('script[data-vt-variants]');
    if (!script) return [];
    try { return JSON.parse(script.textContent); } catch (e) { return []; }
  }

  function initPerUnitOnSize() {
    var variants = loadVariants();
    if (variants.length === 0) return;

    // Find every option fieldset that looks like a size axis
    document.querySelectorAll('fieldset').forEach(function (fs) {
      var legend = fs.querySelector('legend, .form__label');
      var legendText = legend ? legend.textContent.toLowerCase() : '';
      if (!/size|ounce|volume|capacity|ml|oz/.test(legendText)) return;

      var labels = fs.querySelectorAll('label[for]');
      if (labels.length === 0) return;

      var rows = [];
      var minPerUnit = Infinity;
      labels.forEach(function (label) {
        var inputId = label.getAttribute('for');
        var input = document.getElementById(inputId);
        if (!input) return;
        var parsed = parseSize(input.value);
        if (!parsed) return;

        // Match a variant whose option value equals this input value
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v.option1 === input.value || v.option2 === input.value || v.option3 === input.value) {
            if (v.available) { match = v; break; }
            if (!match) match = v;
          }
        }
        if (!match) return;

        var perUnitCents = Math.round(match.price / parsed.qty);
        rows.push({
          label: label,
          input: input,
          size: parsed,
          variant: match,
          perUnitCents: perUnitCents,
        });
        if (perUnitCents < minPerUnit) minPerUnit = perUnitCents;
      });

      if (rows.length === 0) return;

      // Mark the fieldset so CSS can switch to full-width row layout
      fs.classList.add('has-per-oz-data');

      rows.forEach(function (r) {
        // Idempotent: remove previous per-unit elements before re-injecting
        var existing = r.label.querySelectorAll('.size-per-unit, .size-best-badge, .size-row, .size-name-wrap');
        existing.forEach(function (el) { el.remove(); });

        var isBest = r.perUnitCents === minPerUnit && rows.length > 1;
        var unitLabel = r.size.unit;
        var perText = fmtMoney(r.perUnitCents) + ' / ' + unitLabel;

        // Restructure label content as: [size name] [per-unit + badge]
        var existingText = r.label.firstChild && r.label.firstChild.nodeType === 3
          ? r.label.firstChild.textContent.trim()
          : (r.input.value || '');
        // Strip old text nodes so we don't double-stack
        Array.prototype.slice.call(r.label.childNodes).forEach(function (n) {
          if (n.nodeType === 3) r.label.removeChild(n);
        });
        // Also strip any inline ".visually-hidden" labels that the existing snippet adds
        // but keep the unavailable label intact
        var unavailableLabel = r.label.querySelector('.label-unavailable');

        var row = document.createElement('span');
        row.className = 'size-row';

        var left = document.createElement('span');
        left.className = 'size-row-left';
        left.textContent = existingText;

        var right = document.createElement('span');
        right.className = 'size-row-right';

        var per = document.createElement('span');
        per.className = 'size-per-unit' + (isBest ? ' size-per-unit--best' : '');
        per.textContent = perText;
        right.appendChild(per);

        if (isBest) {
          var badge = document.createElement('span');
          badge.className = 'size-best-badge';
          badge.textContent = 'Best / ' + unitLabel;
          right.appendChild(badge);
        }

        row.appendChild(left);
        row.appendChild(right);
        r.label.insertBefore(row, r.label.firstChild);

        if (unavailableLabel) r.label.appendChild(unavailableLabel);
      });
    });
  }

  // ---------- Shipping progress ----------
  // Reads a thresholdCents data attribute on shipping-progress. Computes the
  // current PDP selection's subtotal (variant.price × tier qty) and renders
  // distance + a nudge.
  function getSelectedTierQty(sectionId) {
    var vt = sectionId
      ? document.querySelector('volume-tiers[data-section-id="' + sectionId + '"]')
      : document.querySelector('volume-tiers');
    if (!vt) return 1;
    var checked = vt.querySelector('input[type="radio"]:checked');
    if (!checked) return 1;
    var tier = checked.closest('[data-vt-qty]');
    if (!tier) return 1;
    return parseInt(tier.getAttribute('data-vt-qty'), 10) || 1;
  }

  function getCurrentVariantPrice(sectionId) {
    var formId = sectionId ? 'product-form-' + sectionId : null;
    var form = formId ? document.getElementById(formId) : document.querySelector('form[action*="/cart/add"]');
    if (!form) return 0;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return 0;
    var id = parseInt(idInput.value, 10);
    var vt = sectionId
      ? document.querySelector('volume-tiers[data-section-id="' + sectionId + '"]')
      : document.querySelector('volume-tiers');
    if (!vt) return 0;
    var script = vt.querySelector('script[data-vt-variants]');
    if (!script) return 0;
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (e) { return 0; }
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) return variants[i].price;
    }
    return parseInt(vt.getAttribute('data-base-cents'), 10) || 0;
  }

  function updateShippingProgress(sectionId) {
    var root = sectionId
      ? document.querySelector('shipping-progress[data-section-id="' + sectionId + '"]')
      : document.querySelector('shipping-progress');
    if (!root) return;
    var thresholdCents = parseInt(root.getAttribute('data-threshold-cents'), 10) || 0;
    // If no threshold is configured, hide the whole component — there's
    // nothing meaningful to track and showing "Free shipping unlocked"
    // when threshold is 0 is wrong.
    if (thresholdCents <= 0) {
      root.style.display = 'none';
      return;
    }
    var qty = getSelectedTierQty(sectionId);
    var unitCents = getCurrentVariantPrice(sectionId);
    if (!unitCents) {
      // Variant price unknown — hide instead of showing wrong state
      root.style.display = 'none';
      return;
    }
    root.style.display = '';

    // Apply tier discount approximation (so display matches what cart will charge).
    // Defaults aligned with volume-tiers.liquid (5% / 10%) — previously 10/15
    // would silently kick in if the data attribute was missing, producing a
    // shipping-progress bar that disagreed with the volume-tier savings line.
    var tier2Pct = parseInt(root.getAttribute('data-tier2-pct'), 10) || 5;
    var tier3Pct = parseInt(root.getAttribute('data-tier3-pct'), 10) || 10;
    var fullCents = unitCents * qty;
    var pct = 0;
    if (qty === 2) pct = tier2Pct;
    else if (qty === 3) pct = tier3Pct;
    var saveCents = Math.round(fullCents * pct / 100);
    var subtotalCents = fullCents - saveCents;

    var remainingCents = thresholdCents - subtotalCents;
    var textEl = root.querySelector('.sp-text');
    var barEl = root.querySelector('.sp-bar-fill');
    var nudgeEl = root.querySelector('.sp-nudge');

    if (remainingCents <= 0) {
      root.classList.add('sp-unlocked');
      if (textEl) textEl.innerHTML = '<strong>Free shipping unlocked.</strong>';
      if (barEl) barEl.style.width = '100%';
    } else {
      root.classList.remove('sp-unlocked');
      if (textEl) textEl.innerHTML = '<strong>' + fmtMoney(remainingCents) + '</strong> away from free shipping';
      if (barEl) {
        var pctFilled = Math.max(0, Math.min(100, (subtotalCents / thresholdCents) * 100));
        barEl.style.width = pctFilled + '%';
      }
    }
    // Hide the legacy .sp-nudge button if it exists — the snippet no longer
    // renders it (we removed the volume-tier ladder), but on older cached
    // pages it may still be in the DOM. Keep this guard until the snippet
    // cache flushes everywhere.
    if (nudgeEl) nudgeEl.style.display = 'none';
  }
  // Expose for cross-component calls
  window.__pdpUpdateShippingProgress = updateShippingProgress;

  // Wire the nudge button to bump the volume tier
  document.addEventListener('click', function (e) {
    var nudge = e.target.closest('.sp-nudge');
    if (!nudge) return;
    e.preventDefault();
    var target = nudge.getAttribute('data-bump-to');
    if (!target) return;
    var vt = document.querySelector('volume-tiers');
    if (!vt) return;
    var tier = vt.querySelector('[data-vt-qty="' + target + '"]');
    if (!tier) return;
    var radio = tier.querySelector('input[type="radio"]');
    if (!radio) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ---------- Bundle attach ----------
  function initBundle(root) {
    var addBtn = root.querySelector('[data-ba-add]');
    if (!addBtn) return;
    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var items = [];
      root.querySelectorAll('[data-ba-variant-id]').forEach(function (el) {
        var id = parseInt(el.getAttribute('data-ba-variant-id'), 10);
        if (id) items.push({ id: id, quantity: 1 });
      });
      if (items.length === 0) return;
      var originalLabel = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          // Open cart drawer if available
          var drawer = document.getElementById('CartDrawer');
          if (drawer && typeof drawer.show === 'function') {
            drawer.show();
          } else if (drawer && drawer.removeAttribute) {
            drawer.removeAttribute('hidden');
          }
          // Tell the theme to refresh
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          addBtn.textContent = 'Added ✓';
          setTimeout(function () {
            addBtn.disabled = false;
            addBtn.textContent = originalLabel;
          }, 1500);
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = originalLabel;
        });
    });
  }

  // ---------- Boot ----------
  // Each init wrapped in try/catch so a single failure (missing element,
  // unexpected DOM shape, broken variant data) can't disable the others.
  function safeRun(name, fn) {
    try { fn(); }
    catch (e) {
      if (window && window.console) console.warn('[pdp-offer] ' + name + ' failed:', e);
    }
  }

  // ---------- Quantity-aware price + ATC button label ----------
  // The native price block shows a single variant price. With the quantity
  // selector restored (v92), users expect the price to multiply by qty.
  // We also paint the running total into the ATC button so customers don't
  // have to scroll back up to confirm what they're spending.
  //
  // FoxTheme price.liquid uses the `f-` prefix on every class:
  //   .f-price.f-price--on-sale      (set when compare_at > price)
  //   .f-price__regular              (regular wrapper)
  //   .f-price__sale                 (sale wrapper, contains <s> strikethrough)
  //   .f-price-item.f-price-item--regular  (the actual money span)
  //   .f-price-item.f-price-item--sale     (the sale price span)
  //
  // Sale state: there are TWO .f-price-item--regular elements (one in
  // .f-price__regular which is hidden, one in .f-price__sale's <s> tag).
  // We must target only the VISIBLE money element to multiply, otherwise we
  // mutate hidden DOM and the on-screen price stays at unit. The visible
  // element is .f-price-item--sale when on sale, .f-price-item--regular when not.
  function getProductInfoFor(form) {
    return form && form.closest ? form.closest('product-info') : null;
  }

  function getCurrentVariant(productInfo) {
    if (!productInfo) return null;
    var script = productInfo.querySelector('variant-selects [data-selected-variant]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function getDisplayedQty(form) {
    var input = form ? form.querySelector('input[name="quantity"]') : null;
    if (!input) return 1;
    var n = parseInt(input.value, 10);
    return isNaN(n) || n < 1 ? 1 : n;
  }

  // For single-variant products (no <variant-selects> rendered), fall back to
  // reading the unit price from the visible price element on first paint.
  function getUnitCentsFromPriceBlock(priceBlock) {
    if (!priceBlock) return null;
    var visible = priceBlock.querySelector(
      '.f-price--on-sale .f-price-item--sale, .f-price:not(.f-price--on-sale) .f-price-item--regular'
    );
    if (!visible) {
      visible = priceBlock.querySelector('.f-price-item--regular, .f-price-item--sale');
    }
    if (!visible) return null;
    // Strip everything that isn't a digit or decimal/comma. Don't assume locale.
    var raw = visible.textContent.replace(/[^\d.,-]/g, '').replace(/,/g, '.');
    // Take the LAST decimal point as the separator (handles "1.234,56" → "1.234.56")
    var lastDot = raw.lastIndexOf('.');
    var asNumber;
    if (lastDot >= 0) {
      var intPart = raw.substring(0, lastDot).replace(/\./g, '');
      var fracPart = raw.substring(lastDot + 1);
      asNumber = parseFloat(intPart + '.' + fracPart);
    } else {
      asNumber = parseFloat(raw);
    }
    if (isNaN(asNumber)) return null;
    return Math.round(asNumber * 100);
  }

  function updateQtyAwarePriceAndATC(form) {
    if (!form) return;
    var productInfo = getProductInfoFor(form);
    var sectionId = productInfo
      ? (productInfo.dataset.section || productInfo.dataset.originalSection)
      : null;
    var priceBlock = sectionId ? document.getElementById('price-' + sectionId) : null;

    var variant = getCurrentVariant(productInfo);
    var qty = getDisplayedQty(form);
    var unitCents = null;
    var available = true;

    if (variant && variant.price != null) {
      unitCents = parseInt(variant.price, 10) || 0;
      available = variant.available !== false;
    } else {
      // Single-variant product (or variant data missing): read from price block
      unitCents = getUnitCentsFromPriceBlock(priceBlock);
    }
    if (unitCents == null) return;
    var totalCents = unitCents * qty;

    // Update the visible price line. On sale, that's .f-price-item--sale;
    // otherwise .f-price-item--regular. The hidden compare-at <s> is left alone.
    if (priceBlock) {
      var visiblePrice = priceBlock.querySelector('.f-price--on-sale .f-price-item--sale')
        || priceBlock.querySelector('.f-price:not(.f-price--on-sale) .f-price-item--regular')
        || priceBlock.querySelector('.f-price-item--regular');
      if (visiblePrice) {
        // Always cache the unit-price label so qty=1 restores cleanly. We only
        // populate the cache the first time we see this element — and we only
        // trust it if qty was 1 at the time of caching (otherwise it'd be
        // poisoned by a URL like ?quantity=2 on first load).
        if (visiblePrice.dataset.basePriceLabel == null) {
          if (qty === 1) {
            visiblePrice.dataset.basePriceLabel = visiblePrice.textContent.trim();
          } else {
            // Compute the qty=1 label from the variant price we just read.
            visiblePrice.dataset.basePriceLabel = fmtMoney(unitCents);
          }
        }
        if (qty <= 1) {
          visiblePrice.textContent = visiblePrice.dataset.basePriceLabel;
        } else {
          visiblePrice.textContent = fmtMoney(totalCents);
        }
      }
    }

    // Paint the running total into the ATC button label.
    var atc = form.querySelector('button[name="add"], [name="add"]');
    if (atc) {
      var label = atc.querySelector('span') || atc;
      if (label.dataset.baseAtcLabel == null) {
        label.dataset.baseAtcLabel = (label.textContent.trim() || 'Add to cart');
      }
      if (!available) {
        label.textContent = label.dataset.baseAtcLabel; // FoxTheme owns the "Sold out" string
      } else {
        label.textContent = label.dataset.baseAtcLabel + ' · ' + fmtMoney(totalCents);
      }
    }
  }

  function bindQtyAwareUpdates() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('input', function (e) {
        if (e.target && e.target.name === 'quantity') {
          updateQtyAwarePriceAndATC(form);
        }
      });
      form.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'quantity') {
          updateQtyAwarePriceAndATC(form);
        }
      });
      // Initial paint
      updateQtyAwarePriceAndATC(form);
    });
  }

  function boot() {
    safeRun('volumeTiers', function () {
      document.querySelectorAll('volume-tiers').forEach(function (root) {
        safeRun('volumeTiers init', function () { initVolumeTiers(root); });
      });
    });
    safeRun('bundleAttach', function () {
      document.querySelectorAll('bundle-attach').forEach(function (root) {
        safeRun('bundleAttach init', function () { initBundle(root); });
      });
    });
    safeRun('initPerUnitOnSize', function () { initPerUnitOnSize(); });
    safeRun('updateShippingProgress', function () { updateShippingProgress(); });
    safeRun('bindQtyAwareUpdates', function () { bindQtyAwareUpdates(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-run per-oz + shipping progress after variant swaps the picker DOM.
  //
  // There are TWO events we listen to, on purpose:
  //
  //   optionValueSelectionChange — fires the instant the radio is clicked.
  //     Used for fast feedback in case product-info.js doesn't replace the
  //     fieldset (e.g. scent-only changes that don't trigger a fetch).
  //
  //   variantChange — fires AFTER product-info.js has finished its fetch
  //     and run replaceWith() on the variant-selects element. This is the
  //     event we need to re-apply .has-per-oz-data to the newly-injected
  //     fieldset; without it, the class is on the old (now-detached) node.
  //
  // The old code only listened to optionValueSelectionChange with a 60ms
  // setTimeout — which lost the race against the network fetch and caused
  // the "new style flashes then disappears" symptom.
  if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS) {
    var refreshAfterVariant = function () {
      safeRun('per-oz refresh', function () { initPerUnitOnSize(); });
      safeRun('shipping refresh', function () { updateShippingProgress(); });
      // Repaint the qty-aware total too — product-info.js replaced the price
      // block with the new variant's HTML, so the cached basePriceLabel on the
      // old element is gone; fresh paint gives the correct new total.
      safeRun('qty-aware refresh', function () {
        document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
          updateQtyAwarePriceAndATC(f);
        });
      });
    };

    try {
      window.FoxTheme.pubsub.subscribe(
        window.FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
        function () {
          requestAnimationFrame(refreshAfterVariant);
        }
      );
    } catch (e) { /* ignore */ }

    try {
      if (window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange) {
        window.FoxTheme.pubsub.subscribe(
          window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          function () {
            // Run on the next frame so the just-injected DOM is laid out.
            requestAnimationFrame(refreshAfterVariant);
          }
        );
      }
    } catch (e) { /* ignore */ }
  }

  // Fallback: the theme also dispatches a `variant:changed` CustomEvent on
  // document AFTER updateOptionValues completes. Subscribing here covers
  // any path where the pubsub variantChange isn't published.
  document.addEventListener('variant:changed', function () {
    requestAnimationFrame(function () {
      safeRun('per-oz refresh (variant:changed)', function () { initPerUnitOnSize(); });
      safeRun('shipping refresh (variant:changed)', function () { updateShippingProgress(); });
      safeRun('qty-aware refresh (variant:changed)', function () {
        document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
          updateQtyAwarePriceAndATC(f);
        });
      });
    });
  });
})();
